import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { Error404 } from '../domains';
import AllProject from '../domains/projects/AllProject';
import MyProject from '../domains/projects/MyProject';
import ProjectDetail from '../domains/projects/ProjectDetail';

const ProjectRoutes = () => (
    <Switch>
        <Route exact path="/projects/:projectId" component={ProjectDetail} />
        <Route exact path="/projects/user/my-project" component={MyProject} />

        <Route exact path="/projects" component={AllProject} />

        <Route component={Error404} />
    </Switch>
);

export default ProjectRoutes;
